export const GET_INSTRUCTORS = "GET_INSTRUCTORS";

export const SET_INSTRUCTORS = "SET_INSTRUCTORS";


export const EMAIL_EXISTS = "EMAIL_EXISTS";

export const GET_INSTRUCTORS_BY_CATEGORY = "GET_INSTRUCTORS_BY_CATEGORY";

export const SET_INSTRUCTORS_BY_CATEGORY = "SET_INSTRUCTORS_BY_CATEGORY";